import * as React from "react";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
import { Well } from "components/bootstrap";
import usePluggableLicenseCheck from "hooks/usePluggableLicenseCheck";
import styles from "../event-notification-types/EmailNotificationSummary.css";
const EmailNotificationDetails = ({ notification }) => {
  var _a, _b;
  const { t } = useTranslation("event_notifications");
  const isSecurityLicenseValid = (_b = (_a = usePluggableLicenseCheck("/license/security")) == null ? void 0 : _a.data) == null ? void 0 : _b.valid;
  const yesNo = (value) => value ? t("summary.yes") : t("summary.no");
  const recipients = /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.email_recipients"),
      value: notification.config.email_recipients.join(", ") || t("email_summary.no_email_recipients")
    }
  );
  const recipientLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.recipients_lut_name"),
      value: notification.config.recipients_lut_name
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.recipients_lut_key"), value: notification.config.recipients_lut_key }));
  const ccEmails = /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.cc_emails"),
      value: notification.config.cc_emails.join(", ") || t("email_summary.no_cc_emails")
    }
  );
  const ccLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.cc_lut_name"), value: notification.config.cc_emails_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.cc_lut_key"), value: notification.config.cc_emails_lut_key }));
  const bccEmails = /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.bcc_emails"),
      value: notification.config.bcc_emails.join(", ") || t("email_summary.no_bcc_emails")
    }
  );
  const bccLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.bcc_lut_name"), value: notification.config.bcc_emails_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.bcc_lut_key"), value: notification.config.bcc_emails_lut_key }));
  const sender = /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.sender"), value: notification.config.sender });
  const senderLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_details.sender_lut_name"), value: notification.config.sender_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_details.sender_lut_key"), value: notification.config.sender_lut_key }));
  const replyTo = /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.reply_to"), value: notification.config.reply_to });
  const replyToLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_details.reply_to_lut_name"), value: notification.config.reply_to_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_details.reply_to_lut_key"), value: notification.config.reply_to_lut_key }));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.single_email"), value: yesNo(notification.config.single_email) }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.use_lut_sender"),
      value: yesNo(notification.config.lookup_sender_email)
    }
  ), notification.config.lookup_sender_email ? senderLookupInfo : sender, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.subject"), value: notification.config.subject }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.use_lut_reply_to"),
      value: yesNo(notification.config.lookup_reply_to_email)
    }
  ), notification.config.lookup_reply_to_email ? replyToLookupInfo : replyTo, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.user_recipients"),
      value: notification.config.user_recipients.join(", ") || t("email_summary.no_user_recipients")
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.use_lut_recipients"),
      value: yesNo(notification.config.lookup_recipient_emails)
    }
  ), notification.config.lookup_recipient_emails ? recipientLookupInfo : recipients, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_details.cc_users"),
      value: notification.config.cc_users.join(", ") || t("email_summary.no_cc_users")
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.use_lut_cc"), value: yesNo(notification.config.lookup_cc_emails) }), notification.config.lookup_cc_emails ? ccLookupInfo : ccEmails, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_details.bcc_users"),
      value: notification.config.bcc_users.join(", ") || t("email_summary.no_bcc_users")
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_summary.use_lut_bcc"), value: yesNo(notification.config.lookup_bcc_emails) }), notification.config.lookup_bcc_emails ? bccLookupInfo : bccEmails, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("email_details.time_zone"), value: notification.config.time_zone }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.body"),
      value: /* @__PURE__ */ React.createElement(Well, { bsSize: "small", className: styles.bodyPreview }, notification.config.body_template || /* @__PURE__ */ React.createElement("em", null, t("email_summary.empty_body")))
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.html_body"),
      value: /* @__PURE__ */ React.createElement(Well, { bsSize: "small", className: styles.bodyPreview }, notification.config.html_body_template || /* @__PURE__ */ React.createElement("em", null, t("email_summary.empty_body")))
    }
  ), isSecurityLicenseValid && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("email_summary.include_event_procedure"),
      value: yesNo(notification.config.include_event_procedure)
    }
  ));
};
export default EmailNotificationDetails;
